import styled from 'styled-components'

export const Wrapper = styled.div`
	align-items: stretch;
	display: flex;
	gap: 28px;
	flex-wrap: wrap;
	justify-content: center;
	max-width: 1190px;
	width: 100%;

	@media only screen and (max-width: 800px) {
		align-items: center;
		flex-direction: column;
		gap: 16px;
	}
`
